import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false
  },
  global: {
    headers: {
      'apikey': supabaseAnonKey
    }
  }
});

export interface ContactRequest {
  name: string;
  email: string;
  phone?: string;
  message: string;
  insurance_types: string[];
  source?: string;
}

export async function submitContactRequest(request: ContactRequest) {
  try {
    const { data, error } = await supabase
      .from('contact_requests')
      .insert([{
        ...request,
        source: 'autoinsurance.dk'
      }])
      .select();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error submitting contact request:', error);
    throw error;
  }
}